import { asyncConnect } from 'redux-connect';

import {
  load as loadAuth,
  loadOwnBriefs,
  signUp,
  googleOAuthRedirect,
  sendGoogleOAuthCode,
  update as updateAuthUser,
  // saveBraintreeNonce,
} from 'redux/modules/auth';
import {
  load as loadSuggestedRoles,
  isLoaded as isRolesLoaded,
} from 'redux/modules/suggestedRoles2';
import {
  load as loadSuggestedSkills,
  isLoaded as isSkillsLoaded,
} from 'redux/modules/suggestedSkills2';
import {
  // getPaymentToken,
  inviteUser,
} from 'redux/modules/briefDetails';
import { setSuccessMessage } from 'redux/modules/successMessage';
import { postBrief } from 'redux/modules/briefs';
import { loadStats } from 'redux/modules/stats';
import { loadUser } from 'redux/modules/users';
import loadable from '@loadable/component';

const PostBase = loadable(() => import('./PostBase'));

const Post = asyncConnect(
  [
    {
      promise: ({ location, store: { dispatch, getState } }) => {
        const promises = [];

        const store = getState();

        if (!isRolesLoaded(store)) {
          promises.push(dispatch(loadSuggestedRoles()));
        }

        if (!isSkillsLoaded(store)) {
          promises.push(dispatch(loadSuggestedSkills()));
        }

        if (!store.stats.loadedStats) {
          promises.push(dispatch(loadStats()));
        }

        const {
          query: { freelancerId },
        } = location;

        if (freelancerId && !store.entities.users[freelancerId]) {
          promises.push(dispatch(loadUser(freelancerId)));
        }

        return Promise.all(promises);
      },
    },
  ],
  (state) => ({
    authUser: state.auth.user,
    ownBriefs: state.auth.ownBriefs,
    emailError: state.auth.emailError,
    // loadedPaymentToken: state.briefDetails.loadedPaymentToken,
    loadedSuggestedRoles: state.suggestedRoles2.loaded,
    loadedSuggestedSkills: state.suggestedSkills2.loaded,
    loadingAuth: state.auth.loading,
    // savingBraintreeNonce: state.auth.savingBraintreeNonce,
    // loadingPaymentToken: state.briefDetails.loadingPaymentToken,
    loadingSuggestedRoles: state.suggestedRoles2.loading,
    loadingSuggestedSkills: state.suggestedSkills2.loading,
    passwordError: state.auth.passwordError,
    // paymentToken: state.briefDetails.paymentToken,
    postedBrief: state.briefs.postedBrief,
    postingBrief: state.briefs.postingBrief,
    roleEntities: state.entities.roles,
    signingUp: state.auth.signingUp,
    signedUpToGoogle: state.auth.signedUpToGoogle,
    signingUpViaGoogle: state.auth.signingUpViaGoogle,
    userId: state.auth.userId,
    skillEntities: state.entities.skills,
    suggestedRoles: state.suggestedRoles2.suggestedRoles,
    suggestedSkills: state.suggestedSkills2.suggestedSkills,
    stats: state.stats,
    users: state.entities.users,
    authState: state.auth,
    authLoaded: state.auth.loaded,
  }),
  {
    // getPaymentToken,
    inviteUser,
    loadAuth,
    loadOwnBriefs,
    loadSuggestedRoles,
    loadSuggestedSkills,
    loadStats,
    loadUser,
    postBrief,
    // saveBraintreeNonce,
    setSuccessMessage,
    signUp,
    googleOAuthRedirect,
    sendGoogleOAuthCode,
    updateAuthUser,
  }
)(PostBase);

export default Post;
